// src/store/slices/userProfileSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as con from "../../GlobalConstants";
import axios from "axios";
import { getRequestConfig } from "../logic/supportFunctions";
import * as sf from "../logic/supportFunctions"
import { extractErrorMessage } from "../../utils/errorFunctions";
import { createError } from "../../templates/notifications/Notifications";


export const fetchUserAttributes = createAsyncThunk(
  "userProfile/fetchUserAttributes",
  async (_, { rejectWithValue }) => {
    try {
      const config = getRequestConfig();

      let url = con.rest_base_url + con.user_profile_api;

      if (sf.surrogateActive()) {
        url =
          con.rest_base_url +
          con.staff_user_profile_api +
          `/${sf.getSurrogateUser()[con.ID]}`;
      }

      const res = await axios.get(url, config);
      let data = res.data;

      // Avatar normalization (IMPORTANT: keep this logic here)
      if (
        con.AVATAR_IMAGE in data &&
        data[con.AVATAR_IMAGE] !== null
      ) {
        if (data[con.AVATAR_IMAGE].startsWith("/static/")) {
          data[con.AVATAR_IMAGE] =
            con.rest_base_url + data[con.AVATAR_IMAGE];
        }
      }

      return data;
    } catch (err) {
      return rejectWithValue(extractErrorMessage(err, "Error cargando el perfil de usuario"));
    }
  }
);


const initialState = {
  [con.AVATAR_IMAGE]: null,
  [con.ADVISORS]: [],
  [con.MAIN_ADVISOR]: null,
  profile_status: con.NOT_STARTED,
};

const userProfileSlice = createSlice({
  name: con.REDUCER_USER_PROFILE,
  initialState,
  reducers: {

    addAdivosr: (state, action) => {
      state[con.ADVISORS].push(action.payload);
    },

    deleteAdvisor: (state, action) => {
      const advisorId = action.payload;

      state[con.ADVISORS] = state[con.ADVISORS].filter(
        advisor => advisor.id !== advisorId
      );
    },

    setMainAdvisor: (state, action) => {
      state[con.MAIN_ADVISOR] = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchUserAttributes.pending, (state) => {
        state.profile_status = con.LOADING;
      })

      .addCase(fetchUserAttributes.fulfilled, (state, action) => {
        state.profile_status = con.OK;
        Object.assign(state, action.payload);
      })

      .addCase(fetchUserAttributes.rejected, (state, action) => {
        state.profile_status = con.ERROR;
        createError(action.payload);
      });
  },
});

export const {
  addAdivosr,
  deleteAdvisor,
  setMainAdvisor,
} = userProfileSlice.actions;

export default userProfileSlice.reducer;
